{ "release_sha": "sha", "build_id": "build-id", "build_number": "build-number" }
